


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ImageBlockDto, ImageBlockImageDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';

@Component({
  components: {LoadingIndicator, CmsLink},
})
export default class ImageBlock extends Vue {
  @Prop({required: true})
  public readonly model!: ImageBlockDto;

  public currentIndex: number = 0;
  public imageLoadIndex: number = 0;

  public get currentImage(): ImageBlockImageDto | null {
    return this.model.images[this.currentIndex] ?? null;
  }

  public get imageLocation(): string | null {
    return this.model.images[this.imageLoadIndex]?.imagePath ?? null;
  }

  public get isSlider(): boolean {
    return this.model.images.length > 1;
  }

  public get actionButtonCaption(): string | null {
    return this.currentImage?.buttonCaption ?? null;
  }

  public get hasLinkTarget(): boolean {
    return !!this.currentImage?.link?.target;
  }

  public navigateForward(): void {
    this.navigateTo(this.imageLoadIndex + 1);
  }

  public navigateBack(): void {
    this.navigateTo(this.imageLoadIndex - 1);
  }

  public handleImageLoad(): void {
    this.currentIndex = this.imageLoadIndex;
  }

  public handleSwipe(direction: string): void {
    if (direction === 'right') {
      this.navigateBack();
    } else if (direction === 'left') {
      this.navigateForward();
    }
  }

  private navigateTo(nextIndex: number): void {
    if (nextIndex >= this.model.images.length) {
      this.imageLoadIndex = 0;
    } else if (nextIndex < 0) {
      this.imageLoadIndex = this.model.images.length - 1;
    } else {
      this.imageLoadIndex = nextIndex;
    }
  }
}
